export const queryKeys = {
  session: ['crm', 'session'] as const,
  staff: ['crm', 'staff'] as const,
  snapshot: (personId: string) => ['crm', 'snapshot', personId] as const,
  module: (module: string) => ['crm', module] as const,
}

export const INVALIDATION_MAP: Record<string, readonly string[]> = {
  'assistant.changed': ['assistant'],
  'assistantSettings.changed': ['assistant'],
  'documents.changed': ['documents', 'storage-usage', 'document-usage'],
  'storage.changed': ['documents', 'storage-usage', 'document-usage'],
  'tasks.changed': ['tasks', 'storage-usage', 'document-usage'],
  'orders.changed': ['orders', 'customers', 'production', 'warehouse', 'document-usage'],
  'customers.changed': ['customers', 'orders', 'document-usage'],
  'catalog.changed': ['catalog', 'engineering', 'orders', 'production', 'document-usage'],
  'staff.changed': ['staff', 'documents', 'storage-usage', 'document-usage'],
  'directory.changed': ['staff'],
  'warehouse.changed': [
    'warehouse',
    'purchasing',
    'production',
    'nesting',
    'storage-usage',
    'document-usage',
  ],
  'purchasing.changed': ['purchasing', 'warehouse', 'suppliers', 'document-usage'],
  'suppliers.changed': ['suppliers', 'purchasing', 'document-usage'],
  'production.changed': ['production', 'nesting', 'orders', 'warehouse', 'document-usage'],
  'equipment.changed': ['equipment', 'production'],
  'scrap.changed': ['production', 'equipment'],
  'projects.changed': ['engineering', 'catalog', 'orders', 'storage-usage', 'document-usage'],
  'engineering.changed': ['engineering', 'catalog', 'orders', 'storage-usage', 'document-usage'],
  'logistics.changed': ['logistics', 'orders', 'document-usage'],
  'invoices.changed': ['invoices', 'orders', 'storage-usage', 'document-usage'],
  'paymentRequests.changed': ['payment-requests', 'purchasing', 'storage-usage', 'document-usage'],
  'finance.changed': ['invoices', 'payment-requests', 'orders', 'storage-usage', 'document-usage'],
  'settings.changed': ['settings'],
}
